// extracted by mini-css-extract-plugin
module.exports = {"exchanges":"index-module--exchanges--1dST9","details":"index-module--details--1f_S0","tokenDetails":"index-module--tokenDetails--3U16u"};